export default __webpack_public_path__ + "static/media/c3.b32bf1af.svg";